import { toBoolean } from "@obg/ngx.global";
import { filter, head, includes, some, unescape, union } from "lodash-es";

import { Banner, BannerResponseItem } from "./banner.model";

export function processRawBanner(rawBanner: BannerResponseItem): Banner {
	const {
		title,
		button,
		description,
		termsAndConditionsDescription,
		termsAndConditionsUrl,
		metadata,
		image,
		url,
		homeThumbnailImage,
	} = rawBanner.content;
	const { highlighted, productType, termsAndConditionsApply, groups, bannerType } = metadata;

	return {
		key: rawBanner.documentKey,
		image: head(image),
		title: unescape(head(title)),
		button: head(button),
		description: unescape(head(description)),
		termsAndConditionsDescription: unescape(head(termsAndConditionsDescription)),
		termsAndConditionsUrl: head(termsAndConditionsUrl),
		termsAndConditionsApply: !!toBoolean(head(termsAndConditionsApply)),
		productType: head(productType),
		bannerType: head(bannerType),
		highlighted: !!toBoolean(head(highlighted)),
		groups,
		url: head(url),
		homeThumbnailImage: head(homeThumbnailImage),
	};
}

export function getAllGroups(banners: Banner[] | undefined): string[] {
	let groups: string[] = [];
	banners = banners || [];

	for (const banner of banners) {
		groups = union(groups, banner.groups);
	}
	return groups;
}

export function filterByGroup(banners: Banner[], groups: string[]): Banner[] {
	return filter(banners, (banner) => some(banner.groups, (group) => includes(groups, group)));
}
